import moment, { Moment } from 'moment';
import { APOSTLE, VALID_POSITIONS } from './constants';
import { Callable, Leader } from './types';

export enum CallingColor {
  GRAY = 'GRAY',
  RED = 'RED',
  GREEN = 'GREEN',
  YELLOW = 'YELLOW',
}

export interface CallingHighlight {
  color: CallingColor,
  label?: string,
}

export const getCallingColor = (leader: Leader, date?: Moment, presentPositionCallDate?: string): CallingHighlight => {
  const isReleaseDate = (callable: Callable) => date && callable.releaseDate && date.isSame(callable.releaseDate);
  const isCallDate = (callable: Callable) => date && date.isSame(callable.callDate);

  if (!date) {
    return { color: CallingColor.GRAY };
  }
  if (isReleaseDate(leader)) {
    return {
      color: CallingColor.RED,
      label: leader.deathDate && date.isSame(leader.deathDate) ? 'Died' : 'Released',
    };
  }
  if (date.isSame(leader.callDate) && leader.positions.find(position => position.type === APOSTLE)) {
    return { color: CallingColor.GREEN, label: 'Called as Apostle' };
  }
  const changedPosition = leader.positions.filter(
    position => VALID_POSITIONS.includes(position.type)
  ).find(position => isCallDate(position) || isReleaseDate(position));
  if ((presentPositionCallDate && date.isSame(moment(presentPositionCallDate))) || changedPosition) {
    return {
      color: CallingColor.YELLOW,
      label: changedPosition && !isCallDate(changedPosition)
        ? 'Position Released'
        : 'New Position',
    };
  }
  return { color: CallingColor.GRAY };
};

export const getCallingAccent = (color: CallingColor) => {
  const base = 'bg-gray-100 dark:bg-gray-800 border-l-4';
  switch (color) {
    case CallingColor.RED:
      return `${base} border-red-400 dark:border-red-500`;
    case CallingColor.GREEN:
      return `${base} border-emerald-400`;
    case CallingColor.YELLOW:
      return `${base} border-yellow-400`;
  }
  return `${base} border-transparent`;
};

export const getCallingBadge = (color: CallingColor) => {
  switch (color) {
    case CallingColor.RED:
      return 'bg-red-400 dark:bg-red-500 text-gray-900';
    case CallingColor.GREEN:
      return 'bg-emerald-300 dark:bg-emerald-400 text-gray-900';
    case CallingColor.YELLOW:
      return 'bg-yellow-300 dark:bg-yellow-400 text-gray-900';
  }
  return '';
};
